import React from 'react'
import { Container } from 'react-bootstrap'
import { IBatch } from '../../api/IRecipe'
import { IInfo } from "../../api/IInfo";
import Section from "../overview/Section";
import { Typography } from "@mui/material";
import { Gallery } from "./BatchGallery";
import {useTranslation} from 'react-i18next';

const StarBatchView = ({batch, info}:{batch: IBatch, info: IInfo}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Section
        title={t('pages.landingPage.thisWeek')}
        subtitle={`${t('pages.landingPage.wePropose')} ${batch?.name || t('pages.landingPage.batchInPreparation')}`}>
        <Gallery batch={batch}/>
      </Section>
      <Container fluid className="testimonial py-5">
        <Section title={t('pages.landingPage.statsTitle')} subtitle={t('pages.landingPage.statsSubtitle')}>
          <Typography sx={{fontSize: '1.2rem'}}>
            <strong style={{color: '#f4a261', fontSize: '2em'}}>
              {t('pages.landingPage.recipesCount', { count: info?.numberOfRecipe ?? 500 })}
            </strong>
            {` ${t('pages.landingPage.recipesDescription')}`}
            <strong style={{color: '#f4a261'}}>{t('pages.landingPage.whatToEat')}</strong>
          </Typography>
          <Typography sx={{fontSize: '1.2rem', marginTop: '1rem'}}>
            <strong style={{color: '#f4a261', fontSize: '2em'}}>
              {t('pages.landingPage.batchCookingCount')}
            </strong>
            {t('pages.landingPage.batchCookingDescription')}
          </Typography>
          <Typography sx={{fontSize: '1.2rem', marginTop: '1rem'}}>
            <strong style={{color: '#f4a261', fontSize: '2em'}}>
              {t('pages.landingPage.usersCount', { count: info?.users ?? 30 })}
            </strong>
            {` ${t('pages.landingPage.usersDescription')}`}
          </Typography>
        </Section>

      </Container>
    </>);
}

export default StarBatchView
